//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from '../Component';

//endregion

/** */
type Props = {
    title: string;
    children: JSX.Element | JSX.Element[];
}

/** */
class MFormSection extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <div className="mb-2">
                <div className="mb-3 text-2xl font-light uppercase">
                    {this.props.title}
                </div>
                <div className="formgrid grid">
                    {this.props.children}
                </div>
            </div>
        );

    }

}

export default MFormSection;
